import { render } from "./Incidence_subcategories.vue?vue&type=template&id=e249329a"
import script from "./Incidence_subcategories.vue?vue&type=script&lang=js"
export * from "./Incidence_subcategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__